var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { SubmissionConfiguration as SubmissionConfigurationModel } from "./../models/V1/SubmissionConfiguration/SubmissionConfiguration";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
export class SubmissionConfiguration {
  /**
   * Creates an instance of SubmissionConfiguration.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof SubmissionConfiguration
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param GetRq_ _getRq
   * @returns Promise<GetRq_>
   * @memberof SubmissionConfiguration
   */
  get(pGetRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/SubmissionConfiguration/{companyId}", "GET", "application/json; charset=UTF-8", "text/plain, application/json, text/json", options);
    client.addPathParams([{ name: "companyId", value: pGetRq.companyId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SubmissionConfigurationModel },
        { statusCode: 403, clazz: ApiError },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateCountryRq_ _updateCountryRq
   * @returns Promise<UpdateCountryRq_>
   * @memberof SubmissionConfiguration
   */
  updateCountry(pUpdateCountryRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/SubmissionConfiguration/{companyId}/countries/{countryCode}",
      "PUT",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "companyId", value: pUpdateCountryRq.companyId, required: true },
      { name: "countryCode", value: pUpdateCountryRq.countryCode, required: true }
    ]);
    client.addBody({ value: pUpdateCountryRq.body, isPrimitive: true });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }, { statusCode: 403, clazz: ApiError }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
